<template>
  <div>
    <Compare />
  </div>
</template>

<script>
// @ is an alias to /src
import Compare from '@/components/Compare/Compare.vue'

export default {
  name: 'home',
  components: {
    Compare
  }
}
</script>